(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["learn-gilding-courses"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var filters = root.querySelectorAll('[data-lg-filter]');
    var cards = root.querySelectorAll('[data-lg-course]');
    var countEl = root.querySelector('[data-lg-count]');
    if (!filters.length || !cards.length) return;

    function apply(filter) {
      var visible = 0;
      cards.forEach(function (card) {
        var format = card.getAttribute('data-format') || '';
        var level = card.getAttribute('data-level') || '';
        var match =
          filter === 'all' ||
          format === filter ||
          level === filter ||
          (filter === 'intermediate' && (level === 'intermediate' || level.indexOf('advanced') !== -1));
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (countEl) {
        countEl.textContent = 'Showing ' + visible + (visible === 1 ? ' course' : ' courses');
      }
      filters.forEach(function (btn) {
        var active = btn.getAttribute('data-lg-filter') === filter;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        apply(btn.getAttribute('data-lg-filter'));
      });
    });
  }

  document.querySelectorAll('[data-lg-courses]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();
})();
